const FacebookConnectionState =
{
	UNKNOWN: 0,
	NOT_CONNECTED: 1,
	CONNECTED: 2
}
export default FacebookConnectionState;
